/**
 * 通用校验方法
 */

/** 是否为外部的url */
export const isExternal = (path) => /^(https?:|mailto:|tel:)/.test(path)

/** 判断是否为空(区分number 0) */
export const isEmpty = (value) => value === '' || value === null || value === undefined
